import type { FunctionComponent } from "react";
import { Modal } from "scmp-sdk";

import { useInitializeScmpLoginFormWithEventHandlers, useLoginDialogStateHelper } from "./hooks";
import CloseIcon from "./icon-close.svg";
import {
  CloseButton,
  Container,
  Disclaimer,
  LoginForm,
  PrimaryCloseButton,
  StyledScmpLogo,
} from "./styles";

export const LoginDialog: FunctionComponent = () => {
  const { closeLoginDialog, loginDialogState: state } = useLoginDialogStateHelper();
  const { reference } = useInitializeScmpLoginFormWithEventHandlers();
  const onClose = () => closeLoginDialog();

  return (
    <Modal disableAutoFocus onClose={onClose} open={state.isVisible && state.variant !== "inline"}>
      <Container $variant={state.variant}>
        {state.variant !== "dialog-with-primary-close-button-only" && (
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        )}

        {state.variant !== "dialog-with-primary-close-button-only" && <StyledScmpLogo />}

        <LoginForm>
          <div id="loginContainer" ref={reference} />
        </LoginForm>

        {state.variant === "dialog-with-primary-close-button-only" && (
          <PrimaryCloseButton onClick={onClose}>close</PrimaryCloseButton>
        )}

        {state.variant !== "dialog-with-primary-close-button-only" && (
          <Disclaimer>
            By creating an account, you agree to our{" "}
            <a href="/terms-conditions">Terms of Service</a> and acknowledge our{" "}
            <a href="/privacy-policy">Privacy Policy</a>.
          </Disclaimer>
        )}
      </Container>
    </Modal>
  );
};

LoginDialog.displayName = "LoginDialog";
